module.exports = __webpack_public_path__ + "images/404.1792570018885.png";